import { SingleCombo } from "./single_combo.js";
import { ComboCinema } from "./combo_cinema.js";

export class Initialization {
	initialize(content, type) {
		if (type === "cinema") {
			this._initializeComboCinema(content);
		} else {
			this._initializeCombo(content);
		}
	}

	_initializeCombo(comboContents) {
		let combo;
		[].forEach.call(comboContents, comboElement => {
			if (!this._isInitialized(comboElement)) {
				combo = new SingleCombo(comboElement);

				this._setIsInitialized(comboElement);
				combo.addClickHandlers();
				combo.addWishlistButtonClickHandler();
				combo.sendViewTracking();
			}
		});
	}

	_initializeComboCinema(comboContents) {
		let comboCinema;
		[].forEach.call(comboContents, comboElement => {
			if (!this._isInitialized(comboElement)) {
				comboCinema = new ComboCinema(comboElement);

				this._setIsInitialized(comboElement);
				comboCinema.addClickHandlers();
				comboCinema.initCinemaEvents();
				comboCinema.addWishlistButtonClickHandler();
			}
		});
	}

	_isInitialized(comboElement) {
		return comboElement.getAttribute("data-tracked") === "true";
	}

	_setIsInitialized(comboElement) {
		comboElement.setAttribute("data-tracked", "true");
	}
}
